
// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container fluid grid-list-md>
    <error-snackbar v-model="errorText"></error-snackbar>
    <v-card>
      <v-toolbar flat>
        <v-btn icon @click="exit"><v-icon>clear</v-icon></v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="isNew" class="mx-1" dark color="green" @click="saveShare">Create</v-btn>
        <v-btn v-if="!isNew" class="mx-1" dark color="blue" @click="updateShare">Update</v-btn>
        <v-btn v-if="!isNew" class="mx-1" dark color="red" @click="deleteDialogVisible = true">Delete</v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row v-if="shareUrl && !isNew" align="center">
          <v-col cols="6">
            <v-text-field
              label="Share URL"
              v-model="shareUrl"
              disabled
            ></v-text-field>
          </v-col>
          <v-col>
            <v-btn icon @click="copyShareUrl"><v-icon>content_copy</v-icon></v-btn>
          </v-col>
        </v-row>
        <v-row wrap>
          <v-col cols="12" md="6">
            <v-text-field
              name="input"
              label="Collection Name"
              v-model="shareAlbum.name"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row wrap>
          <v-col cols="12">
            <v-text-field
              name="description"
              label="Description"
              v-model="shareAlbum.description"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-autocomplete
              label="Shared Categories"
              v-model="shareAlbum.categoryIDs"
              v-bind:items="getCategories"
              item-text="name"
              item-value="id"
              multiple
              chips
            ></v-autocomplete>
          </v-col>
          <v-col id="tags">
            <v-autocomplete
              label="Shared Tags"
              v-model="shareAlbum.tags"
              v-bind:items="getTags"
              item-text="name"
              item-value="id"
              multiple
              chips
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="mt-2" align="center">
          <v-col cols="12">
            <p class="combine-mode-hint text-body-2 mb-2">{{ combineModeHint }}</p>
            <v-btn-toggle v-model="shareAlbum.combineMode" mandatory dense color="primary">
              <v-btn value="or" small>Any (OR)</v-btn>
              <v-btn value="and" small>All (AND)</v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="deleteDialogVisible" max-width="400px">
      <v-card>
        <v-card-title>
          <div class="headline">Delete?</div>
        </v-card-title>
        <v-card-text>Are you sure you want to delete this share?  This action cannot be undone.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.native="deleteDialogVisible = false">Cancel</v-btn>
            <v-btn text color="red" @click.native="deleteShare">I'm Sure</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { ENDPOINT } from '@/shared/constants'
import DetailView from '@sdgsystems/vue-common/components/DetailView.vue'
import { mapGetters } from 'vuex/dist/vuex.common.js'
import ApiRequests from '@/api/ApiRequests.js'
import ErrorSnackbar from '@sdgsystems/vue-common/components/ErrorSnackbar'

export default {
  components: {
    DetailView,
    ErrorSnackbar
  },

  created () {
    this.param = this.$route.params.id
    this.isNew = this.param === 'new'
    console.log(window.location.origin)
    console.log('Router', this.$route)

    this.getShare()
  },

  watch: {
    shareAlbum () {
      if (this.shareAlbum !== '') {
        this.shareUrl = window.location.origin + '/#/share/' + this.shareAlbum.uuid
      }
    }
  },

  methods: {
    getShare: function () {
      if (!this.isNew) {
        this.shareAlbum.uuid = this.param
        console.log('existing share')
        ApiRequests.getShare(this.shareAlbum.uuid)
          .then(r => {
            console.log(r.data)
            this.shareAlbum = r.data
            if (this.shareAlbum.combineMode !== 'or') {
              this.$set(this.shareAlbum, 'combineMode', 'and')
            }
          })
          .catch(e => {
            console.log('error: ' + e)
          })
      }
    },

    copyShareUrl: function () {
      navigator.clipboard.writeText(this.shareUrl).then(() => {
        this.errorText = 'Share URL copied to clipboard'
      }).catch(e => {
        console.error('Failed to copy share URL: ' + e)
        this.errorText = 'Failed to copy share URL: ' + e
      })
    },

    deleteShare: function () {
      this.deleteDialogVisible = false
      ApiRequests.deleteShare(this.shareAlbum.id)
        .then(r => {
          console.log(r.data)
        })
        .catch(e => {
          console.log('Error deleting: ' + e)
        })
    },

    updateShare: function () {
      ApiRequests.updateShare(this.shareAlbum)
        .then(r => {
          console.log('Update', r.data)
          this.exit()
        })
        .catch(e => {
          console.log('Error updating: ' + e)
        })
    },

    saveShare: function () {
      ApiRequests.postShare(this.shareAlbum).then(response => {
        this.exit()
      }).catch((e) => {
        console.error(e)
        this.errorText = 'Error: ' + e.response.data.error
      })
    },

    exit: function () {
      this.$router.push({name: 'shares'})
    }
  },

  computed: {
    ...mapGetters([
      'getCategories',
      'getTags'
    ]),

    combineModeHint: function () {
      if (this.shareAlbum.combineMode === 'or') {
        return 'This will add photos to the public collection that have ANY of the shared categories or tags.'
      }
      return 'This will add photos to the public collection that have ALL of the shared categories and tags.'
    }
  },

  data () {
    return {
      shareAlbum: {
        combineMode: 'and',
        categoryIDs: [],
        tags: []
      },
      shareUrl: '',
      isNew: true,
      param: '',
      endpoint: ENDPOINT,
      deleteDialogVisible: false,
      errorText: ''
    }
  }
}
</script>

<style scoped>
.combine-mode-hint {
  color: rgba(0, 0, 0, 0.57);
}
.theme--dark .combine-mode-hint {
  color: rgba(255, 255, 255, 0.6);
}
</style>



// WEBPACK FOOTER //
// ShareEdit.vue?59dc28c7